/**
 *
 * @param {HTMLElement} productElement
 * @param {Object} product
 */
export const computePositionStyles = (product) => {
	// # Současně jdeme vždy k 100% výšky a šířky parent elementu
	const BASE_WIDTH = "100%";
	const BASE_HEIGHT = "100%";

	const { width, height, coordinates } = product;
	const { left, top } = coordinates;

	const positionStyles = {};

	positionStyles.width = calcRelativePercentage(width, BASE_WIDTH);

	positionStyles.height = calcRelativePercentage(height, BASE_HEIGHT);

	positionStyles.left = calcRelativePercentage(left, BASE_WIDTH);

	positionStyles.top = calcRelativePercentage(top, BASE_HEIGHT);

	return positionStyles;
};

const calcRelativePercentage = (percentage, base, offset = 0) => {
	return `calc(${percentage}*${base} + ${offset}px)`;
};
